import { render, staticRenderFns } from "./bill-view.vue?vue&type=template&id=2de8335e&scoped=true&"
import script from "./bill-view.vue?vue&type=script&lang=js&"
export * from "./bill-view.vue?vue&type=script&lang=js&"
import style0 from "./bill-view.vue?vue&type=style&index=0&id=2de8335e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8335e",
  null
  
)

export default component.exports